import { render, staticRenderFns } from "./LetsTalk.vue?vue&type=template&id=4281e182&scoped=true"
import script from "./LetsTalk.vue?vue&type=script&lang=js"
export * from "./LetsTalk.vue?vue&type=script&lang=js"
import style0 from "./LetsTalk.vue?vue&type=style&index=0&id=4281e182&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4281e182",
  null
  
)

export default component.exports